import { AppBar, Dialog, Slide, Toolbar, WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ISkillAdminViewProps } from 'src/components/SkillMain';
import { IRootState } from 'src/reducers';
import SkillScenarioFactory, {
	ISkillParam,
} from 'src/scenario/SkillScenarioFactory';
import * as Actions from '../actions/skill';
import { ISessionState } from '../reducers/session';
import { ISkillState, ISkstate } from '../reducers/skill';
import i18n from '../resources/i18n';
import { CMItemCode, isValid } from '../utils/CMData';
import SkillDetail from './SkillDetail';
import SkillMapTable from './SkillMapTable';
import SkillTable from './SkillTable';
import { SkillTableTypes } from './SkillTable';
export enum TabRow {
	SKILL,
	SKILLMAP,
}
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		caption: {
			marginTop: -14,
		},
		detailDialog: {
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		paper: {
			marginBottom: theme.spacing(1),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			marginTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(0),
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
	});

interface IState {
	showSkillId: string;
	openSkillDetailDialog: boolean;
}

class SkillOnGoing extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			openSkillDetailDialog: false,
			showSkillId: '',
		};
	}

	public componentDidMount() {
		const param: ISkillParam = {
			adminView: this.props.adminView,
			userAttr: this.props.userAttr,
			userId: this.props.userId,
		};
		this.props.doFetchOnGoingSkill(this.props.token, param);
		if (isValid(CMItemCode.CM_SKILLMAP_ENABLED)) {
			this.props.doFetchOnGoingSkillMap(this.props.token, param);
		}
	}

	public render() {
		const { classes, onGoingSkill, onGoingSkillMap } = this.props;

		return (
			<>
				<Paper className={classes.paper} id="skill">
					<Grid container={true} alignItems="flex-end">
						<Grid item={true} className={classes.flex}>
							<Typography variant="h6">
								{i18n.t('SkillOnGoing_0001')}
							</Typography>
						</Grid>
						<Grid item={true}>
							<IconButton
								onClick={this.reloadOnGoing(TabRow.SKILL)}
								color="primary"
							>
								<RefreshIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('SkillOnGoing_0002')}
							</Typography>
						</Grid>
					</Grid>
					<Skill
						skill={onGoingSkill}
						userId={this.props.userId}
						adminView={this.props.adminView}
						handleShowSkillDetailDialog={
							this.handleShowSkillDetailDialog
						}
					/>
				</Paper>
				{isValid(CMItemCode.CM_SKILLMAP_ENABLED) && (
					<Paper className={classes.paper} id="skillmap">
						<Grid container={true} alignItems="flex-end">
							<Grid item={true} className={classes.flex}>
								<Typography variant="h6">
									{i18n.t('SkillOnGoing_0003')}
								</Typography>
							</Grid>
							<Grid item={true}>
								<IconButton
									onClick={this.reloadOnGoing(
										TabRow.SKILLMAP
									)}
									color="primary"
								>
									<RefreshIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									className={classes.caption}
									display="block"
								>
									{i18n.t('SkillOnGoing_0002')}
								</Typography>
							</Grid>
						</Grid>
						<SkillMap
							skillMap={onGoingSkillMap}
							userId={this.props.userId}
							adminView={this.props.adminView}
						/>
					</Paper>
				)}
				<Dialog
					fullScreen={false}
					TransitionComponent={Transition}
					open={this.state.openSkillDetailDialog}
					onClose={this.handleCloseSkillDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: classes.detailDialog,
						scrollPaper: classes.scrollPaper,
					}}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handleCloseSkillDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('SkillOnGoing_0004')}
							</Typography>
						</Toolbar>
					</AppBar>
					<SkillDetail skillId={this.state.showSkillId} />
				</Dialog>
			</>
		);
	}

	/**
	 * 表示情報取得
	 */
	protected reloadOnGoing = (tableType: number) => () => {
		const param: ISkillParam = {
			adminView: this.props.adminView,
			userAttr: this.props.userAttr,
			userId: this.props.userId,
		};
		switch (tableType) {
			case TabRow.SKILL:
				this.props.doFetchOnGoingSkill(this.props.token, param);
				break;
			case TabRow.SKILLMAP:
				this.props.doFetchOnGoingSkillMap(this.props.token, param);
				break;
			default:
		}
	};

	/**
	 * スキル詳細情報画面を開く
	 * @param event スキル名のクリックイベント
	 */
	protected handleShowSkillDetailDialog = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const skillId = event.currentTarget.getAttribute('data-skillid');
		if (skillId) {
			this.setState({
				openSkillDetailDialog: true,
				showSkillId: skillId,
			});
		}
	};

	/**
	 * スキル詳細情報画面閉じるハンドラ
	 */
	protected handleCloseSkillDetailDialog = () => {
		this.setState({ showSkillId: '', openSkillDetailDialog: false });
	};
}

interface ISkillProps {
	skill: ISkstate<Actions.IOnGoingSkill>;
	userId: string;
	adminView: boolean;

	handleShowSkillDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
}

const Skill: React.FC<ISkillProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};
	return (
		<div style={style}>
			<SkillTable
				data={props.skill.data}
				selectedColumns={props.skill.selectedColumns}
				type={SkillTableTypes.ONGOING}
				adminView={props.adminView}
				userId={props.userId}
				handleShowSkillDetailDialog={props.handleShowSkillDetailDialog}
			/>
		</div>
	);
};

const Transition: React.FC<any> = props => {
	return <Slide direction="up" {...props} />;
};

interface ISkillMapProps {
	skillMap: ISkstate<Actions.IOnGoingSkillMap>;
	userId: string;
	adminView: boolean;
}

const SkillMap: React.FC<ISkillMapProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};
	return (
		<div style={style}>
			<SkillMapTable
				data={props.skillMap.data}
				selectedColumns={props.skillMap.selectedColumns}
				type={SkillTableTypes.ONGOING}
				adminView={props.adminView}
				userId={props.userId}
			/>
		</div>
	);
};

const mapStateToProps = (state: IRootState) => ({
	onGoingSkill: state.skill.onGoingSkill,
	onGoingSkillMap: state.skill.onGoingSkillMap,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchOnGoingSkill: (token: string, skillParam: ISkillParam) => {
		const s = SkillScenarioFactory.createDoFetchOnGoingSkill(
			dispatch,
			token
		);
		return s.run(skillParam);
	},
	doFetchOnGoingSkillMap: (token: string, skillParam: ISkillParam) => {
		const s = SkillScenarioFactory.createDoFetchOnGoingSkillMap(
			dispatch,
			token
		);
		return s.run(skillParam);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	ISkillAdminViewProps &
	ISkillState &
	ISessionState;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SkillOnGoing);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ISkillAdminViewProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/SkillOnGoing.tsx